var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5674 53.757L48.7443 53.583C39.9334 53.5134 36.3632 45.3836 36.4279 37.3384L36.4975 31.471C36.6566 12.0043 52.5333 0.0905603 72 0.244703L71.7812 26.9362C71.7265 33.8826 66.0481 39.4715 59.0968 39.4118L55.9642 39.387V40.2174L59.0271 40.2422C72.0845 40.3466 71.6271 46.0052 71.5674 52.9913V53.757Z",
    fill: "#F15E58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.432591 52.9912C0.377896 46.01 -0.0845318 40.3515 12.9728 40.2421L16.0408 40.2172V39.3868L12.9032 39.4117C5.95686 39.4664 0.278452 33.8825 0.218784 26.9361L0 0.244554C19.4667 0.0854394 35.3434 12.0041 35.5025 31.4709L35.5721 37.3382C35.6368 45.3835 32.0716 53.5133 23.2556 53.5829L0.432591 53.7569V52.9912Z",
    fill: "#F15E58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickerIcon);
export default __webpack_public_path__ + "static/media/kicker-icon.cf452ddeaa2cccbaeadef3b736a1d617.svg";
export { ForwardRef as ReactComponent };